export default __webpack_public_path__ + "media/images/friends-cropped-f3ad7410b60e7cfc988ad5e48a3f0fea.png";